import * as actions from 'actions';

const INITIAL_STATE = {
  isRejected: false,
  reason: null,
  expirationDate: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case actions.CHAT_ENQUEUE_ERROR: {
      if(!action.error.isRejected) {
        return state;
      }

      return {
        isRejected: true,
        reason: action.error.message,
        expirationDate: action.error.expirationDate
      };
    }

    case actions.CHAT_QUEUE_REJECTION_EXPIRE:
      return INITIAL_STATE;

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/queueRejection/reducer.js
 **/